import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import Filters from './Filters';

import { ReactComponent as IconClose } from '../../../../assets/images/close.svg';
import { loadersByName, popupByName, TARGET_ID_MODAL, togglePopup } from '../../../../store/ui';
import { useMedia } from '../../../context/InterfaceContext';
import Breadcrumbs from '../base/breadcrumbs';
import Container from '../base/container';
import Title from '../base/title';
import Button, { ButtonKind } from '../button/Button';
import Portal from '../Portal';

export const FiltersModal = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const { isFullMobile } = useMedia();
    const { opened } = useSelector(popupByName('location_filter'));
    const loaderSearch = useSelector(loadersByName('searchNearMe'));

    if (loaderSearch) {
        return null;
    }

    if (opened) {
        return (
            <Portal id={TARGET_ID_MODAL}>
                <div className={'filter-modal-wrapper'}>
                    <Breadcrumbs
                        pageName={intl.formatMessage({ id: 'general.productName', defaultMessage: 'Product Finder' })}
                    />

                    <Title
                        title={intl.formatMessage({ id: 'location.filter.title', defaultMessage: 'Standorte filtern' })}
                        rightSide={
                            <Button
                                kind={ButtonKind.LINK}
                                onClick={() => dispatch(togglePopup({ name: 'location_filter', status: false }))}
                            >
                                <IconClose width={isFullMobile ? 18 : 22} height={isFullMobile ? 18 : 22} />
                            </Button>
                        }
                    />

                    <Container classNamesContainer={'location__container'}>
                        <Filters />
                    </Container>
                </div>
            </Portal>
        );
    }

    return null;
};
